import { UserType } from 'Core/interfaces'

import i18n from '../utils/i18nService'

export const paths = []

export enum Permission {
	REPORTING_VIEW = 'RPT_VIEW',
	WS_VIEW = 'WS_VIEW',
	ADMIN_VIEW = 'ADMIN_VIEW',
	PM_VIEW = 'PM_VIEW',
	CUST_MANIFEST_VIEW = 'CUST_MANIFEST_VIEW',
	CUSTOMER_MOU = 'CUSTOMER_MOU',
	CUSTOMER_INVOICE_VIEW = 'CUST_INVC_VIEW',
	CUSTOMER_ORDER_VIEW = 'CUST_ORDER_VIEW',
	EHS_AUDIT = 'EHS_AUDIT'
}

export const allowedUserTypes: UserType[] = [
	UserType.CUSTOMER,
	UserType.DATA_MANAGEMENT,
	UserType.NEW_CUSTOMER
]

export enum UserRole {}

export enum UrlParams {
	id = 'ID',
	name = 'NAME',
	itemId = 'ITEM_ID',
	itemName = 'ITEM_NAME',
	startDate = 'START_DATE',
	endDate = 'END_DATE',
	statusId = 'STATUS_ID',
	stateId = 'STATE_ID',
	reportName = 'REPORT_NAME',
	manifestDocumentNumber = 'MANIFEST_DOCUMENT_NUMBER',
	disposalFacility = 'DISPOSAL_FACILITY',
	cityName = 'CITY_NAME',
	document = 'DOCUMENT',
	mouNumber = 'MOU_NUMBER',
	subject = 'SUBJECT',
	includeUnpaid = 'INCLUDE_UNPAID',
	issuedDateFrom = 'ISSUED_DATE_FROM',
	issuedDateTo = 'ISSUED_DATE_TO',
	locationName = 'LOCATION_NAME',
	sector = 'SECTOR',
	region = 'REGION',
	group = 'GROUP',
	divison = 'DIVISION',
	onlySelectedLocations = 'ONLY_SELECTED_LOCATIONS',
	kpiCategoryId = 'KPI_CATEGORY_ID',
	kpiCategory = 'KPI_CATEGORY',
	kpi = 'KPI',
	kpiCategoryMetric = 'KPI_CATEGORY_METRIC',
	kpiId = 'KPI_ID',
	createdUserId = 'CREATED_USER_ID',
	updatedUserId = 'UPDATED_USER_ID',
	exportCode = 'EXPORT_CODE',
	createDateFrom = 'CREATE_DATE_FROM',
	createDateTo = 'CREATE_DATE_TO',
	updateDateFrom = 'UPDATE_DATE_FROM',
	updateDateTo = 'UPDATE_DATE_TO',
	isUpdatedOnly = 'IS_UPDATED_ONLY',
	isExceedThreshold = 'IS_EXCEED_THRESHOLD',
	year = 'YEAR',
	serviceSiteId = 'LOCATION_ID',
	businessUnit = 'BUSINESS_UNIT',
	serviceLocationId = 'SERVICE_LOCATION_ID',
	billingLocationId = 'BILLING_LOCATION_ID',
	programManagerId = 'PROGRAM_MANAGER_ID',
	poId = 'PO_ID',
	poNumber = 'PO_NUMBER',
	refCodeFilter = 'REF_CODE_FILTER',
	supplierLocationId = 'SUPPLIER_LOCATION_ID',
	serviceSiteName = 'SVC_SITE_NAME',
	refCode = 'REF_CODE',
	supplierLocationName = 'SUPPLIER_LOCATION_NAME',
}

export enum UrlParamsLabel {
	mouNumberLabel = 'MOU_NUMBER_LABEL',
	subjectLabel = 'SUBJECT_LABEL',
	manifestIdLabel = 'MANIFEST_ID_LABEL',
	manifestNameLabel = 'MANIFEST_NAME_LABEL',
	manifestDocumentNumber = 'MANIFEST_DOCUMENT_NUMBER_LABEL',
	disposalFacility = 'DISPOSAL_FACILITY_LABEL',
	companyLocation = 'COMPANY_LOCATION',
	userCreator = 'USER_CREATOR',
	userUpdater = 'USER_UPDATER',
	poIdLabel = 'PO_ID_LABEL',
	poNumberLabel = 'PO_NUMBER_LABEL'
}

export const MEASURE_STRING_MAX_LENGTH = 250

export const getAllOptions = (): LabelValue => ({
	label: i18n.t('constants:ALL'),
	value: ''
})
